import { render, staticRenderFns } from "./IframeView2.vue?vue&type=template&id=36c8f4c1&"
import script from "./IframeView2.vue?vue&type=script&lang=js&"
export * from "./IframeView2.vue?vue&type=script&lang=js&"
import style0 from "./IframeView2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports